export default "__VITE_ASSET__Bqxzhfhd__"